import { parse } from 'query-string';
import { useLocation } from 'react-router';

export const useFilterFromParams = () => {
  const filterParam = parse(useLocation().search).filter;
  return Array.isArray(filterParam) ? (filterParam.shift() as string) : filterParam;
};
